import React, { Component } from 'react';
import { numberWithCommas } from './numberWithCommas';

class PercentFormatter extends Component {
  render() {
    const { value } = this.props;
    return <span>{ (value !== null && !isNaN(value) && `${numberWithCommas(value)}%`) }</span>;
  }
}

export default PercentFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/percentFormatter.jsx